/*
 * Auto-add free gift with discount code (Shopify Dawn theme)
 * ---------------------------------------------------------
 * Flow when the customer clicks "Apply" with the code:
 *   1. The script pauses the theme's request and adds the gift to the cart first.
 *   2. Only then the code is sent to Shopify, so it applies to the gift.
 *   3. The theme renders the cart itself (no page reload).
 *   4. If Shopify did not make the gift free (discount not valid), the gift is
 *      removed and the theme receives the correct, updated cart.
 *
 * Also: code removed -> gift removed. Optional cleanup: after any other cart
 * change, if the gift is no longer free it is removed (cleanupOnCartChange).
 * Only gift lines added by this script are touched (hidden property _auto_gift).
 */
(function () {
  'use strict';

  var CONFIG = {
    code: 'PROFINISH',          // discount code
    giftHandle: '5495501',      // product handle (from the product URL)
    giftVariantId: null,        // optional: a specific variant ID, e.g. 41234567890123
    giftQuantity: 1,
    cleanupOnCartChange: true,  // remove the gift if it stops being free after a cart change
    debug: false                // true = print log lines to the browser console
  };

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var PROP = '_auto_gift';
  var nativeFetch = window.fetch.bind(window);

  function log() {
    if (CONFIG.debug) console.log.apply(console, ['[auto-gift]'].concat([].slice.call(arguments)));
  }

  function api(path, body) {
    var init = {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin'
    };
    if (body) init.body = JSON.stringify(body);
    return nativeFetch(ROOT + path, init).then(function (r) {
      if (!r.ok) throw new Error(path + ' ' + r.status);
      return r.json();
    });
  }

  function getGiftVariantId() {
    if (CONFIG.giftVariantId) return Promise.resolve(Number(CONFIG.giftVariantId));
    return api('products/' + CONFIG.giftHandle + '.js').then(function (p) {
      var v = p.variants.filter(function (x) { return x.available; })[0];
      return v ? v.id : null; // null = out of stock
    });
  }

  function isGiftLine(item) { return !!(item.properties && item.properties[PROP]); }
  function isFree(item) { return item.final_line_price === 0; }
  function findGift(cart) { return cart.items.filter(isGiftLine)[0]; }

  // ---- Read the theme's request body --------------------------------------

  function readBody(body) {
    if (!body) return null;
    try {
      if (typeof body === 'string') {
        if (body.charAt(0) === '{') return JSON.parse(body);
        body = new URLSearchParams(body);
      }
      if (body instanceof FormData || body instanceof URLSearchParams) {
        var obj = {};
        body.forEach(function (v, k) { obj[k] = v; });
        return obj;
      }
    } catch (e) {}
    return null;
  }

  function codeInList(list) {
    return String(list || '').split(',').some(function (c) {
      return c.trim().toLowerCase() === CONFIG.code.toLowerCase();
    });
  }

  // ---- Step 1: before the coupon request ---------------------------------

  // Returns true if the gift was added by this call
  function beforeDiscount(wantsCode) {
    return api('cart.js').then(function (cart) {
      var gift = findGift(cart);
      if (wantsCode) {
        if (gift) return false;
        return getGiftVariantId().then(function (vid) {
          if (!vid) { log('gift out of stock'); return false; }
          var props = {};
          props[PROP] = CONFIG.code;
          log('adding gift before applying code', vid);
          return api('cart/add.js', {
            items: [{ id: vid, quantity: CONFIG.giftQuantity, properties: props }]
          }).then(function () { return true; });
        });
      }
      if (gift) {
        log('code removed -> removing gift');
        return api('cart/change.js', { id: gift.key, quantity: 0 }).then(function () { return false; });
      }
      return false;
    });
  }

  // ---- Step 2: after the coupon request -----------------------------------

  function afterDiscount(response, input, init) {
    return api('cart.js').then(function (cart) {
      var gift = findGift(cart);
      if (!gift || isFree(gift)) return response;
      log('discount not valid -> removing gift and re-sending the coupon request');
      return api('cart/change.js', { id: gift.key, quantity: 0 }).then(function () {
        // Same request again, so the theme renders the cart without the gift
        return nativeFetch(input, init);
      });
    }).catch(function (e) { log('error', e); return response; });
  }

  // ---- Cleanup after other cart changes ----------------------------------

  function afterCartChange(response, body) {
    return api('cart.js').then(function (cart) {
      var gift = findGift(cart);
      if (!gift || isFree(gift)) return response;
      log('gift no longer free -> removing');
      var req = { id: gift.key, quantity: 0 };
      // Ask for the same rendered sections the theme asked for,
      // and hand that response to the theme so it renders the right cart.
      if (body && body.sections) {
        req.sections = body.sections;
        if (body.sections_url) req.sections_url = body.sections_url;
      }
      return nativeFetch(ROOT + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify(req)
      });
    }).catch(function (e) { log('error', e); return response; });
  }

  // ---- Hook into the theme's cart requests --------------------------------

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var body = readBody(init && init.body);

    // "Apply" / remove coupon
    if (/\/cart\/update/.test(url) && body && Object.prototype.hasOwnProperty.call(body, 'discount')) {
      var wantsCode = codeInList(body.discount);
      return beforeDiscount(wantsCode)
        .catch(function (e) { log('error', e); return false; })
        .then(function (added) {
          return nativeFetch(input, init).then(function (response) {
            return added ? afterDiscount(response, input, init) : response;
          });
        });
    }

    // Any other cart change by the theme
    if (CONFIG.cleanupOnCartChange && /\/cart\/(change|update)/.test(url)) {
      return nativeFetch(input, init).then(function (response) {
        return afterCartChange(response, body);
      });
    }

    return nativeFetch(input, init);
  };
})();